<div mat-dialog-content class="mt--sm">
  <span class="color--navy" style="overflow-wrap: break-word">{{ data.message }}</span>
</div>

<div class="row display-column-flex justify-content-center" mat-dialog-actions>
  <div class="row display-column-flex w-100 row-gap--sm">
    @if (data.showZplOption) {
      <button mat-button class="primary-button rounded w-100" (click)="onConfirm(LABEL_TYPE.ZPL)">
        <span class="icon-check mr--xs"></span>
        <span>{{ 'App.PrintConfirmation.Buttons.PrintZpl' | translate }}</span>
      </button>
    }
    @if (data.showPdfOption) {
      <button mat-button class="hollow-button rounded w-100" (click)="onConfirm(LABEL_TYPE.PDF)">
        <span class="icon-check mr--xs"></span>
        <span>{{ 'App.PrintConfirmation.Buttons.ViewPdf' | translate }}</span>
      </button>
    }
    <button mat-button mat-dialog-close class="secondary-button rounded w-100">
      <span class="icon-x mr--xs"></span>
      <span>{{ 'App.PrintConfirmation.Buttons.Cancel' | translate }}</span>
    </button>
  </div>
</div>
